/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useEffect, useRef } from 'react';
import { Network, Data } from 'vis-network';
export const NetworkDisplay = ({
  nodes,
  edges
}: Data) => {
  const networkRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = networkRef.current;
    const options = {
      layout: {
        hierarchical: {
          direction: 'UD',
          nodeSpacing: 155,
          sortMethod: 'directed'
        }
      },
      nodes: {
        borderWidth: 0,
        size: 40,
        color: {
          border: '#222',
          background: 'transparent'
        },
        font: {
          color: '#ffffff',
          face: 'monospace',
          size: 14,
          strokeWidth: 1,
          strokeColor: '#222'
        }
      },
      edges: {
        color: {
          color: '#CCC',
          highlight: '#A22'
        },
        width: 3,
        length: 300,
        hoverWidth: 0.05
      },
      physics: false,
      interaction: {
        hover: true,
        keyboard: {
          enabled: false,
          bindToWindow: false
        },
        navigationButtons: false,
        zoomView: false
      }
    };
    let network: Network;
    if (container) {
      network = new Network(container, {
        nodes,
        edges
      }, options);
      network.moveTo?.({
        // Forces network starting Y position to ensure content is not clipped off at the bottom of the canvas
        position: {
          x: 0,
          y: 15
        }
      });
    }
    return () => {
      network.destroy?.();
    };
  }, [nodes, edges]);
  return <div ref={networkRef} data-sentry-component="NetworkDisplay" data-sentry-source-file="network-display.tsx" />;
};